import Mention from './mention';
import mapProps from '../scripts/utils/map-props';

export default mapProps([
  'value',
])(Mention);
